<script setup lang="ts">
  defineOptions({
    name: 'SidebarIcon',
  })

  import { computed, type PropType } from 'vue'

  import { twMerge, type ClassNameValue } from 'tailwind-merge'

  const props = defineProps({
    iconName: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    class: {
      type: [String, Object, Array] as PropType<ClassNameValue>,
      required: false,
      default: undefined,
    },
  })

  // Single symbol from the `sidebar` sprite. `-active` is appended when active;
  // every sidebar icon ships an `-active.svg` pair (enforced by
  // sidebar-icon-active-pairs.spec.ts), so the symbol always resolves.
  const iconName = computed(() => `sidebar/${props.iconName}${props.isActive ? '-active' : ''}`)
</script>

<template>
  <SpriteSymbol :name="iconName" :class="twMerge(['h-4 w-4 flex-shrink-0', props.class])" v-bind="$attrs" />
</template>
